import styled from 'styled-components';

export const Container = styled.div`
  /* your styles here */
  margin: 2rem 0 0;
`;

